module.exports = __webpack_public_path__ + "images/emoji/arrow_down.62f64fa7c51c0ad7c99c.png";